export const SET_PICS = "SET_PICS"
export const SET_PICS_LOADING = "SET_PICS_LOADING"

export const SET_NOTIFS = "SET_NOTIFS"
export const SET_NOTIFS_LOADING = "SET_NOTIFS_LOADING"
export const SET_NOTIFS_IMPORTANT =  "SET_NOTIFS_IMPORTANT"